(function () {
  function productString(key) {
    return ((window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings[key]) || '').toString();
  }

  function selectAvailableVariantMessage(state) {
    var template = productString('selectAvailableVariant') || productString('bundleSelectVariants');
    var title = state && state.product && state.product.title ? state.product.title : '';
    return template.replace('[product]', title);
  }

  function isDrawerMode() {
    return !window.Axiom || (window.Axiom.cartType || 'drawer') === 'drawer';
  }

  function readProductData(root) {
    var script = root.querySelector('[data-hero-hotspots-products]');
    if (!script) return { products: [] };
    try {
      var data = JSON.parse(script.textContent || '{}');
      return data && typeof data === 'object' ? data : { products: [] };
    } catch (error) {
      return { products: [] };
    }
  }

  function formatMoney(cents) {
    if (window.Axiom && typeof window.Axiom.formatMoney === 'function') {
      return window.Axiom.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function renderPriceHtml(variant) {
    if (!variant) return '';
    var price = Number(variant.price || 0);
    var compare = Number(variant.compare_at_price || 0);
    if (compare > price) {
      return '<div class="price-block" data-on-sale>' +
        '<span class="price-block__sale">' + formatMoney(price) + '</span>' +
        '<span class="price-block__compare"><s>' + formatMoney(compare) + '</s></span>' +
      '</div>';
    }
    return '<div class="price-block"><span class="price-block__regular">' + formatMoney(price) + '</span></div>';
  }

  function getVariantImage(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image;
    if (product && product.featured_image && product.featured_image.src) return product.featured_image;
    return null;
  }

  function updateVariantImage(imageElement, image) {
    if (!imageElement || imageElement.tagName !== 'IMG' || !image || !image.src) return;
    imageElement.removeAttribute('srcset');
    imageElement.removeAttribute('sizes');
    imageElement.src = image.src;
    imageElement.alt = image.alt || '';
  }

  function findVariant(product, selectedOptions) {
    if (window.AxiomVariantForm && typeof window.AxiomVariantForm.findVariant === 'function') {
      var selected = {};
      (selectedOptions || []).forEach(function (value, index) {
        selected[index + 1] = value;
      });
      return window.AxiomVariantForm.findVariant(product, selected);
    }

    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (value, index) {
        return String(value) === String(selectedOptions[index]);
      });
    }) || null;
  }

  function firstAvailableVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function (variant) {
      return variant && variant.available;
    }) || (product && product.selected_or_first_available_variant) || null;
  }

  function variantFromSelectionState(selectionState) {
    var variant = selectionState && selectionState.variant;
    if (!variant) return null;
    var variantState = selectionState.variantState || {};
    return {
      id: variant.id,
      title: variant.title,
      available: Boolean(variant.available),
      requiresSellingPlan: Boolean(variantState.requiresSellingPlan),
      price: variant.price,
      compare_at_price: variant.compare_at_price,
      options: Array.isArray(variant.options) ? variant.options.slice() : [],
      featured_image: variant.featured_image || null,
      quantityRule: variantState.quantityRule || { min: 1, max: null, increment: 1 }
    };
  }

  function selectedOptionValueIds(state) {
    var ids = [];
    var buttons = Array.prototype.slice.call(state.item.querySelectorAll('[data-hero-hotspots-option]'));
    (state.selectedOptions || []).forEach(function (selectedValue, optionIndex) {
      var selectedButton = buttons.find(function (button) {
        return Number(button.dataset.optionPosition) === optionIndex + 1 &&
          String(button.dataset.value || '') === String(selectedValue || '');
      });
      if (selectedButton && selectedButton.dataset.optionValueId) ids.push(selectedButton.dataset.optionValueId);
    });
    return ids;
  }

  function selectionVariantStateMap(selectionState) {
    var variant = selectionState && selectionState.variant;
    var variantState = selectionState && selectionState.variantState;
    if (!variant || !variantState) return null;
    var stateMap = {};
    stateMap[String(variant.id)] = variantState;
    return stateMap;
  }

  function variantQuantityRule(variant, variantState) {
    if (window.AxiomVariantForm && typeof window.AxiomVariantForm.getQuantityRule === 'function') {
      return window.AxiomVariantForm.getQuantityRule(variant, variantState);
    }

    var rule = variant && variant.quantityRule ? variant.quantityRule : {};
    return {
      min: Math.max(0, Number(rule.min || 1)),
      max: rule.max == null ? null : Number(rule.max),
      increment: Math.max(1, Number(rule.increment || 1))
    };
  }

  function normalizeQuantity(value, variant, variantState) {
    if (!variant || !variant.available) return 0;
    if (window.AxiomVariantForm && typeof window.AxiomVariantForm.normalizeQty === 'function') {
      return window.AxiomVariantForm.normalizeQty(value, variant, variantState, false);
    }

    var rule = variantQuantityRule(variant, variantState);
    var quantity = parseInt(value, 10);
    if (!Number.isFinite(quantity) || quantity < rule.min) quantity = rule.min;
    if (rule.max != null && Number.isFinite(rule.max)) quantity = Math.min(quantity, rule.max);
    if (rule.increment > 1) {
      quantity = Math.max(rule.min, Math.round(quantity / rule.increment) * rule.increment);
    }
    return quantity;
  }

  function setStatus(root, message, isError) {
    var status = root.querySelector('[data-hero-hotspots-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.disabled = Boolean(loading);
    button.classList.toggle('is-loading', Boolean(loading));
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function setStickyOverlapSuspended(root, suspended) {
    if (!root || !root.classList.contains('section-sticky-overlap')) return;
    if (suspended) {
      root.setAttribute('data-sticky-overlap-suspended', 'true');
    } else {
      root.removeAttribute('data-sticky-overlap-suspended');
    }
  }

  function openLookDrawer(root, returnFocus) {
    var drawer = root.querySelector('[data-hero-hotspots-drawer]');
    if (!drawer) return;
    var header = document.querySelector('.nav');
    if (header && header._axiomStickyController && typeof header._axiomStickyController.syncOverlayTop === 'function') {
      header._axiomStickyController.syncOverlayTop();
    }
    setStickyOverlapSuspended(root, true);
    var firstOption = drawer.querySelector('[data-hero-hotspots-option]:not([aria-disabled="true"]), [data-hero-hotspots-drawer-add], [data-hero-hotspots-drawer-close]');
    if (window.Axiom && typeof window.Axiom.openDrawer === 'function') {
      window.Axiom.openDrawer(drawer, null, {
        autofocus: true,
        focusTarget: firstOption,
        returnFocus: returnFocus,
        trapFocus: true
      });
      return;
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.documentElement.classList.add('is-scroll-locked');
    if (firstOption && typeof firstOption.focus === 'function') firstOption.focus();
  }

  function closeLookDrawer(root, options) {
    options = options || {};
    var drawer = root.querySelector('[data-hero-hotspots-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (window.Axiom && typeof window.Axiom.closeDrawer === 'function') {
      if (options.restoreFocus === false) delete drawer._drawerReturnFocus;
      window.Axiom.closeDrawer(drawer);
    } else {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      document.documentElement.classList.remove('is-scroll-locked');
    }
    if (!options.preserveStickyOverlapSuspension) setStickyOverlapSuspended(root, false);
  }

  function initVariantDrawer(root) {
    var data = readProductData(root);
    var products = Array.isArray(data.products) ? data.products : [];
    var states = [];

    root.querySelectorAll('[data-hero-hotspots-drawer-item]').forEach(function (item) {
      var index = parseInt(item.dataset.productIndex, 10);
      var product = products[index];
      if (!product) return;

      var highVariantState = window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.read(item);
      var highVariantEnabled = Boolean(window.AxiomHighVariantPicker && window.AxiomHighVariantPicker.isHighVariant(highVariantState));
      var activeVariant = highVariantEnabled ? variantFromSelectionState(highVariantState) : firstAvailableVariant(product);
      var variantStateMap = highVariantEnabled ? selectionVariantStateMap(highVariantState) : null;
      var selectedOptions = activeVariant && Array.isArray(activeVariant.options) ? activeVariant.options.slice() : [];
      var qtyInput = item.querySelector('[data-hero-hotspots-qty-input]');
      var state = {
        item: item,
        product: product,
        selectedOptions: selectedOptions,
        activeVariant: activeVariant,
        quantity: normalizeQuantity(qtyInput ? qtyInput.value : 1, activeVariant, variantStateMap),
        highVariantEnabled: highVariantEnabled,
        highVariantState: highVariantState,
        variantStateMap: variantStateMap,
        requestController: null,
        pending: false
      };

      states.push(state);
      syncDrawerItem(state);
    });

    return states;
  }

  function syncDrawerItem(state) {
    var item = state.item;
    var variant = state.activeVariant;
    var price = item.querySelector('[data-hero-hotspots-drawer-price]');
    var image = item.querySelector('img.hero-product-hotspots__look-image');
    var qtyInput = item.querySelector('[data-hero-hotspots-qty-input]');
    var minus = item.querySelector('[data-hero-hotspots-qty-minus]');
    var plus = item.querySelector('[data-hero-hotspots-qty-plus]');
    var isAvailable = Boolean(variant && variant.available);
    var rule = variantQuantityRule(variant, state.variantStateMap);

    if (price) price.innerHTML = renderPriceHtml(variant);
    updateVariantImage(image, variant ? getVariantImage(variant, state.product) : null);

    state.quantity = normalizeQuantity(state.quantity, variant, state.variantStateMap);
    if (qtyInput) {
      qtyInput.value = state.quantity;
      qtyInput.min = isAvailable ? rule.min : 0;
      qtyInput.step = rule.increment;
      if (rule.max != null && Number.isFinite(rule.max)) {
        qtyInput.max = rule.max;
      } else {
        qtyInput.removeAttribute('max');
      }
      qtyInput.disabled = !isAvailable;
    }
    if (minus) minus.disabled = !isAvailable || state.quantity <= rule.min;
    if (plus) plus.disabled = !isAvailable || (rule.max != null && Number.isFinite(rule.max) && state.quantity >= rule.max);

    syncOptionButtons(state);
  }

  function syncDrawerButtonPrice(states, button) {
    if (!button) return;
    var current = button.querySelector('[data-hero-hotspots-button-price-current]');
    var compare = button.querySelector('[data-hero-hotspots-button-price-compare]');
    if (!current || !compare) return;

    var total = 0;
    var compareTotal = 0;
    states.forEach(function (state) {
      var variant = state.activeVariant;
      if (!variant || !variant.available || state.quantity <= 0) return;
      var price = Number(variant.price || 0);
      var comparePrice = Number(variant.compare_at_price || 0);
      total += price * state.quantity;
      compareTotal += Math.max(price, comparePrice) * state.quantity;
    });

    current.textContent = formatMoney(total);
    compare.hidden = compareTotal <= total;
    compare.textContent = compareTotal > total ? formatMoney(compareTotal) : '';
  }

  function syncOptionButtons(state) {
    var product = state.product;
    var highVariantValues = new Map();
    if (state.highVariantEnabled) {
      (state.highVariantState && state.highVariantState.options || []).forEach(function (option) {
        (option.values || []).forEach(function (value) {
          highVariantValues.set(String(option.position) + ':' + String(value.id), value);
        });
      });
    }

    state.item.querySelectorAll('[data-hero-hotspots-selected-value]').forEach(function (label) {
      var position = parseInt(label.dataset.heroHotspotsSelectedValue, 10);
      label.textContent = state.selectedOptions[position - 1] || '';
    });

    state.item.querySelectorAll('[data-hero-hotspots-option]').forEach(function (button) {
      var position = parseInt(button.dataset.optionPosition, 10);
      var optionIndex = position - 1;
      var value = button.dataset.value || '';
      var candidateOptions = state.selectedOptions.slice();
      candidateOptions[optionIndex] = value;
      var candidateVariant = state.highVariantEnabled ? null : findVariant(product, candidateOptions);
      var highVariantValue = state.highVariantEnabled
        ? highVariantValues.get(String(position) + ':' + String(button.dataset.optionValueId || ''))
        : null;
      var isUnavailable = state.highVariantEnabled
        ? !highVariantValue || !highVariantValue.available
        : !candidateVariant || !candidateVariant.available;
      var isActive = String(state.selectedOptions[optionIndex]) === String(value);

      button.classList.toggle('is-active', isActive);
      button.classList.toggle('is-unavailable', isUnavailable);
      var baseLabel = button.dataset.optionBaseLabel || button.getAttribute('aria-label') || '';
      button.setAttribute('aria-label', baseLabel + (isUnavailable ? ', ' + productString('unavailable') : ''));
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.removeAttribute('aria-disabled');
    });
  }

  function buildDrawerItemsPayload(states) {
    var result = {
      items: [],
      invalidState: null,
      sellingPlanState: null
    };

    states.forEach(function (state) {
      if (!state.activeVariant || !state.activeVariant.available || state.quantity <= 0) {
        if (!result.invalidState) result.invalidState = state;
        return;
      }
      if (state.activeVariant.requiresSellingPlan) {
        if (!result.sellingPlanState) result.sellingPlanState = state;
        return;
      }
      var item = {
        id: state.activeVariant.id,
        quantity: state.quantity
      };
      if (state.product.manualPreorder) {
        item.properties = {};
        item.properties[state.product.preorderPropertyName || '_manual_preorder'] = state.product.preorderPropertyValue || 'true';
      }
      result.items.push(item);
    });

    return result;
  }

  function focusInvalidDrawerState(state) {
    if (!state || !state.item) return;
    if (typeof state.item.scrollIntoView === 'function') {
      state.item.scrollIntoView({ block: 'nearest' });
    }
    var selected = state.item.querySelector('[data-hero-hotspots-option].is-active');
    var fallback = state.item.querySelector('[data-hero-hotspots-option], [data-hero-hotspots-qty-input]');
    var target = selected || fallback;
    if (target && typeof target.focus === 'function') target.focus();
  }

  function showSellingPlanStatus(status, state) {
    if (!status || !state || !state.product) return;
    status.replaceChildren();
    status.appendChild(document.createTextNode(productString('sellingPlanRequired')));
    status.appendChild(document.createTextNode(' '));
    var link = document.createElement('a');
    link.href = state.product.url;
    link.textContent = productString('choosePurchaseOptions');
    link.dataset.heroHotspotsPurchaseOptionsLink = '';
    status.appendChild(link);
    status.classList.add('is-error');

    focusInvalidDrawerState(state);
  }

  function initHeroProductHotspots(root) {
    if (!root || root.dataset.heroHotspotsBound === 'true') return;
    root.dataset.heroHotspotsBound = 'true';
    var controller = window.AbortController ? new AbortController() : null;
    var cleanupCallbacks = [];
    root.heroProductHotspotsAbort = controller;
    root.heroProductHotspotsCleanups = cleanupCallbacks;

    var hotspots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-hotspot]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hero-hotspot-panel]'));
    var activeTrigger = null;
    var activeId = '';
    var initialHotspot = hotspots.find(function (hotspot) {
      return hotspot.dataset.heroHotspotExpanded === 'true' && !hotspot.classList.contains('hero-product-hotspots__hotspot--empty');
    });
    var addAllButton = root.querySelector('[data-hero-hotspots-add-all]');
    var drawerAddButton = root.querySelector('[data-hero-hotspots-drawer-add]');
    var drawerStatus = root.querySelector('[data-hero-hotspots-drawer-status]');
    var drawerStates = initVariantDrawer(root);
    cleanupCallbacks.push(function () {
      drawerStates.forEach(function (state) {
        if (state.requestController) state.requestController.abort();
      });
    });
    syncDrawerButtonPrice(drawerStates, drawerAddButton);
    var refreshMediaMap = createMediaMapUpdater(root, controller, cleanupCallbacks);
    refreshMediaMap();

    function isVisible(element) {
      return Boolean(element && element.getClientRects().length && window.getComputedStyle(element).visibility !== 'hidden');
    }

    function focusActivePopup(id) {
      window.requestAnimationFrame(function () {
        var containers = Array.prototype.slice.call(root.querySelectorAll(
          '[data-hero-hotspot-id="' + CSS.escape(id) + '"] .hero-product-hotspots__label-content, ' +
          '[data-hero-hotspot-panel][data-hero-hotspot-id="' + CSS.escape(id) + '"]'
        ));
        var container = containers.find(isVisible);
        if (!container) return;
        var target = Array.prototype.find.call(
          container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          isVisible
        );
        if (target) target.focus({ preventScroll: true });
      });
    }

    function setActive(id, options) {
      options = options || {};
      activeId = id || '';

      hotspots.forEach(function (hotspot) {
        var isActive = hotspot.dataset.heroHotspotId === activeId;
        hotspot.classList.toggle('is-active', isActive);
        hotspot.querySelectorAll('[data-hero-hotspot-trigger]').forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
        hotspot.querySelectorAll('.hero-product-hotspots__label-content').forEach(function (content) {
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          content.toggleAttribute('inert', !isActive);
        });
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.heroHotspotId === activeId;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        panel.toggleAttribute('inert', !isActive);
      });

      root.classList.toggle('has-active-panel', Boolean(activeId));
      if (activeId && options.focusPopup) focusActivePopup(activeId);
      if (!activeId && options.restoreFocus && activeTrigger && activeTrigger.isConnected) {
        activeTrigger.focus({ preventScroll: true });
      }
      if (!activeId) activeTrigger = null;
    }

    root.heroProductHotspotsSetActive = setActive;

    if (initialHotspot) {
      setActive(initialHotspot.dataset.heroHotspotId);
    }

    function toggleHotspot(hotspot, trigger) {
      if (!hotspot || hotspot.classList.contains('hero-product-hotspots__hotspot--empty')) return;
      var id = hotspot.dataset.heroHotspotId;
      if (activeId === id) {
        setActive('', { restoreFocus: true });
        return;
      }
      activeTrigger = trigger;
      setActive(id, { focusPopup: true });
    }

    addListener(root, 'click', function (event) {
      var trigger = event.target.closest('[data-hero-hotspot-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      var hotspot = trigger.closest('[data-hero-hotspot]');
      if (hotspot && hotspot.dataset.dragged === 'true') return;
      toggleHotspot(hotspot, trigger);
    }, controller, cleanupCallbacks);

    addListener(document, 'click', function (event) {
      if (!activeId || root.contains(event.target)) return;
      setActive('');
    }, controller, cleanupCallbacks);

    addListener(document, 'keydown', function (event) {
      if (event.key === 'Escape' && activeId) setActive('', { restoreFocus: true });
    }, controller, cleanupCallbacks);

    if (addAllButton) {
      addListener(addAllButton, 'click', function () {
        if (!drawerStates.length) {
          var hasProducts = Number(root.dataset.heroProductCount || 0) > 0;
          setStatus(root, hasProducts ? (root.dataset.errorMessage || 'No available variants to add.') : (root.dataset.emptyMessage || 'No available products to add.'), true);
          return;
        }

        setStatus(root, '');
        openLookDrawer(root, addAllButton);
      }, controller, cleanupCallbacks);
    }

    addListener(document, 'theme:cart-drawer:close', function () {
      var drawer = root.querySelector('[data-hero-hotspots-drawer]');
      if (drawer && drawer.classList.contains('is-open')) return;
      setStickyOverlapSuspended(root, false);
    }, controller, cleanupCallbacks);

    root.querySelectorAll('[data-hero-hotspots-drawer-close]').forEach(function (button) {
      addListener(button, 'click', function () {
        closeLookDrawer(root);
      }, controller, cleanupCallbacks);
    });

    addListener(root, 'click', function (event) {
      var optionButton = event.target.closest('[data-hero-hotspots-option]');
      if (!optionButton || !root.contains(optionButton)) return;
      event.preventDefault();

      var item = optionButton.closest('[data-hero-hotspots-drawer-item]');
      var state = drawerStates.find(function (candidate) {
        return candidate.item === item;
      });
      if (!state) return;

      var position = parseInt(optionButton.dataset.optionPosition, 10);
      state.selectedOptions[position - 1] = optionButton.dataset.value || '';
      if (drawerStatus) {
        drawerStatus.textContent = '';
        drawerStatus.classList.remove('is-error');
      }

      if (!state.highVariantEnabled) {
        state.activeVariant = findVariant(state.product, state.selectedOptions);
        state.quantity = normalizeQuantity(state.quantity || 1, state.activeVariant, state.variantStateMap);
        syncDrawerItem(state);
        syncDrawerButtonPrice(drawerStates, drawerAddButton);
        return;
      }

      syncOptionButtons(state);
      var optionValueIds = selectedOptionValueIds(state);
      if (optionValueIds.length !== state.selectedOptions.length || !window.AxiomHighVariantPicker) {
        state.activeVariant = null;
        state.variantStateMap = null;
        state.quantity = 0;
        syncDrawerItem(state);
        syncDrawerButtonPrice(drawerStates, drawerAddButton);
        return;
      }

      if (state.requestController) state.requestController.abort();
      var requestController = window.AbortController ? new AbortController() : null;
      state.requestController = requestController;
      state.pending = true;
      setLoading(drawerAddButton, true);

      window.AxiomHighVariantPicker.request(
        state.product.url,
        optionValueIds,
        requestController ? requestController.signal : undefined
      ).then(function (selectionState) {
        if (state.requestController !== requestController) return;
        state.highVariantState = selectionState;
        state.activeVariant = variantFromSelectionState(selectionState);
        state.variantStateMap = selectionVariantStateMap(selectionState);
        if (state.activeVariant && Array.isArray(state.activeVariant.options)) {
          state.selectedOptions = state.activeVariant.options.slice();
        }
        state.quantity = normalizeQuantity(state.quantity || 1, state.activeVariant, state.variantStateMap);
        syncDrawerItem(state);
        syncDrawerButtonPrice(drawerStates, drawerAddButton);
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (state.activeVariant && Array.isArray(state.activeVariant.options)) {
          state.selectedOptions = state.activeVariant.options.slice();
          syncDrawerItem(state);
        }
        if (drawerStatus) {
          drawerStatus.textContent = error && error.message ? error.message : (root.dataset.errorMessage || 'Could not select this variant.');
          drawerStatus.classList.add('is-error');
        }
      }).finally(function () {
        if (state.requestController !== requestController) return;
        state.requestController = null;
        state.pending = false;
        setLoading(drawerAddButton, drawerStates.some(function (candidate) { return candidate.pending; }));
      });
    }, controller, cleanupCallbacks);

    addListener(root, 'click', function (event) {
      var quantityButton = event.target.closest('[data-hero-hotspots-qty-minus], [data-hero-hotspots-qty-plus]');
      if (!quantityButton || !root.contains(quantityButton)) return;
      event.preventDefault();

      var item = quantityButton.closest('[data-hero-hotspots-drawer-item]');
      var state = drawerStates.find(function (candidate) {
        return candidate.item === item;
      });
      if (!state) return;

      var rule = variantQuantityRule(state.activeVariant, state.variantStateMap);
      var direction = quantityButton.matches('[data-hero-hotspots-qty-plus]') ? 1 : -1;
      state.quantity = normalizeQuantity((state.quantity || rule.min) + (direction * rule.increment), state.activeVariant, state.variantStateMap);
      syncDrawerItem(state);
      syncDrawerButtonPrice(drawerStates, drawerAddButton);
    }, controller, cleanupCallbacks);

    root.querySelectorAll('[data-hero-hotspots-qty-input]').forEach(function (input) {
      addListener(input, 'change', function () {
        var item = input.closest('[data-hero-hotspots-drawer-item]');
        var state = drawerStates.find(function (candidate) {
          return candidate.item === item;
        });
        if (!state) return;
        state.quantity = normalizeQuantity(input.value, state.activeVariant, state.variantStateMap);
        syncDrawerItem(state);
        syncDrawerButtonPrice(drawerStates, drawerAddButton);
      }, controller, cleanupCallbacks);
    });

    addListener(document, 'keydown', function (event) {
      if (event.key === 'Escape') closeLookDrawer(root);
    }, controller, cleanupCallbacks);

    if (drawerAddButton) {
      addListener(drawerAddButton, 'click', function () {
        var payload = buildDrawerItemsPayload(drawerStates);
        if (payload.invalidState) {
          if (drawerStatus) {
            drawerStatus.textContent = selectAvailableVariantMessage(payload.invalidState) || root.dataset.errorMessage || 'Could not add look to cart.';
            drawerStatus.classList.add('is-error');
          }
          focusInvalidDrawerState(payload.invalidState);
          return;
        }
        if (payload.sellingPlanState) {
          showSellingPlanStatus(drawerStatus, payload.sellingPlanState);
          return;
        }
        if (!payload.items.length) {
          if (drawerStatus) {
            drawerStatus.textContent = root.dataset.emptyMessage || 'No available products';
            drawerStatus.classList.add('is-error');
          }
          return;
        }

        if (drawerStatus) {
          drawerStatus.textContent = '';
          drawerStatus.classList.remove('is-error');
        }
        if (!window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.addLines !== 'function') {
          if (drawerStatus) {
            drawerStatus.textContent = root.dataset.errorMessage || 'Could not add look to cart.';
            drawerStatus.classList.add('is-error');
          }
          return;
        }

        if (window.AxiomAddToCartAnimation) {
          var itemsViewport = root.querySelector('.hero-product-hotspots__look-items');
          var viewportRect = itemsViewport ? itemsViewport.getBoundingClientRect() : null;
          var animationItems = drawerStates.map(function (state) {
            var image = getVariantImage(state.activeVariant, state.product);
            var thumbnail = state.item.querySelector('img.hero-product-hotspots__look-image');
            var thumbnailRect = thumbnail ? thumbnail.getBoundingClientRect() : null;
            var thumbnailVisible = thumbnailRect && viewportRect &&
              thumbnailRect.bottom > viewportRect.top && thumbnailRect.top < viewportRect.bottom;
            return {
              source: thumbnailVisible ? thumbnail : drawerAddButton,
              imageUrl: image && image.src,
              quantity: state.quantity
            };
          });
          window.AxiomAddToCartAnimation.play({
            button: drawerAddButton,
            items: animationItems,
            mode: 'main'
          });
        }
        setLoading(drawerAddButton, true);

        window.AxiomStandardStorefront.addLines(payload.items, { target: root, source: 'hero-product-hotspots' })
          .then(function (cart) {
            setStatus(root, '', false);
            closeLookDrawer(root, {
              restoreFocus: !isDrawerMode(),
              preserveStickyOverlapSuspension: isDrawerMode()
            });
            return cart;
          })
          .catch(function (error) {
            var message = error && (error.description || error.message || error.status) ? (error.description || error.message || error.status) : (root.dataset.errorMessage || 'Could not add look to cart.');
            if (drawerStatus) {
              drawerStatus.textContent = message;
              drawerStatus.classList.add('is-error');
            } else {
              setStatus(root, message, true);
            }
          })
          .finally(function () {
            setLoading(drawerAddButton, false);
          });
      }, controller, cleanupCallbacks);
    }

    if (root.dataset.heroHotspotsDesignMode === 'true') {
      bindDesignModeDrag(root);
    }
  }

  function createMediaMapUpdater(root, controller, cleanupCallbacks) {
    var frame = root.querySelector('[data-hero-hotspots-area]');
    var stage = frame ? frame.closest('.hero-product-hotspots__stage') : null;
    var image = frame ? frame.querySelector('.hero-product-hotspots__image, .hero-product-hotspots__placeholder') : null;
    var updateFrame = null;
    var lastMap = null;
    var observedFrameBox = null;
    var observedStageBox = null;
    var resizeObserver = null;

    function getObservedBox(entry) {
      if (!entry) return null;
      var borderBoxSize = entry.borderBoxSize;
      var borderBox = borderBoxSize && (borderBoxSize[0] || borderBoxSize);
      var width = borderBox && Number.isFinite(borderBox.inlineSize)
        ? borderBox.inlineSize
        : entry.contentRect && entry.contentRect.width;
      var height = borderBox && Number.isFinite(borderBox.blockSize)
        ? borderBox.blockSize
        : entry.contentRect && entry.contentRect.height;
      if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
      return { width: width, height: height };
    }

    function getObjectPosition(value) {
      var parts = String(value || '').trim().split(/\s+/);

      function resolve(part, axis, fallback) {
        var normalized = String(part || '').toLowerCase();
        var keywordPositions = axis === 'x'
          ? { left: 0, center: 0.5, right: 1 }
          : { top: 0, center: 0.5, bottom: 1 };

        if (Object.prototype.hasOwnProperty.call(keywordPositions, normalized)) {
          return keywordPositions[normalized];
        }

        if (normalized.slice(-1) === '%') {
          var percentage = parseFloat(normalized);
          if (Number.isFinite(percentage)) return percentage / 100;
        }

        return fallback;
      }

      return {
        x: resolve(parts[0], 'x', 0.5),
        y: resolve(parts[1], 'y', 0.5)
      };
    }

    function getContainRect(containerRect, mediaWidth, mediaHeight, position) {
      if (!containerRect.width || !containerRect.height || !mediaWidth || !mediaHeight) {
        return {
          left: 0,
          top: 0,
          width: containerRect.width || 0,
          height: containerRect.height || 0
        };
      }

      var containerRatio = containerRect.width / containerRect.height;
      var mediaRatio = mediaWidth / mediaHeight;
      var width = containerRect.width;
      var height = containerRect.height;
      var left = 0;
      var top = 0;

      if (mediaRatio > containerRatio) {
        height = width / mediaRatio;
        top = (containerRect.height - height) * position.y;
      } else {
        width = height * mediaRatio;
        left = (containerRect.width - width) * position.x;
      }

      return {
        left: left,
        top: top,
        width: width,
        height: height
      };
    }

    function getCoverRect(containerRect, mediaWidth, mediaHeight, position) {
      if (!containerRect.width || !containerRect.height || !mediaWidth || !mediaHeight) {
        return {
          left: 0,
          top: 0,
          width: containerRect.width || 0,
          height: containerRect.height || 0
        };
      }

      var containerRatio = containerRect.width / containerRect.height;
      var mediaRatio = mediaWidth / mediaHeight;
      var width = containerRect.width;
      var height = containerRect.height;
      var left = 0;
      var top = 0;

      if (mediaRatio > containerRatio) {
        width = height * mediaRatio;
        left = (containerRect.width - width) * position.x;
      } else {
        height = width / mediaRatio;
        top = (containerRect.height - height) * position.y;
      }

      return {
        left: left,
        top: top,
        width: width,
        height: height
      };
    }

    function updateMap(frameRect, stageRect) {
      if (!frameRect || !stageRect || !image) return false;
      var isRasterImage = image.tagName === 'IMG';
      var naturalWidth = isRasterImage ? image.naturalWidth : frameRect.width;
      var naturalHeight = isRasterImage ? image.naturalHeight : frameRect.height;
      if (!naturalWidth || !naturalHeight) return false;
      var imageStyle = window.getComputedStyle(image);
      var objectPosition = getObjectPosition(imageStyle.objectPosition);
      var useCoverMap = imageStyle.objectFit === 'cover';
      var mediaRect = useCoverMap
        ? getCoverRect(frameRect, naturalWidth, naturalHeight, objectPosition)
        : getContainRect(frameRect, naturalWidth, naturalHeight, objectPosition);
      var mapRect = {
        left: frameRect.left - stageRect.left + mediaRect.left,
        top: frameRect.top - stageRect.top + mediaRect.top,
        width: mediaRect.width,
        height: mediaRect.height
      };

      if (
        lastMap &&
        Math.abs(lastMap.left - mapRect.left) < 0.5 &&
        Math.abs(lastMap.top - mapRect.top) < 0.5 &&
        Math.abs(lastMap.width - mapRect.width) < 0.5 &&
        Math.abs(lastMap.height - mapRect.height) < 0.5
      ) {
        stage.setAttribute('data-hero-hotspots-map-ready', 'true');
        return true;
      }

      lastMap = mapRect;

      stage.style.setProperty('--hero-hotspots-map-left', mapRect.left + 'px');
      stage.style.setProperty('--hero-hotspots-map-top', mapRect.top + 'px');
      stage.style.setProperty('--hero-hotspots-map-width', mapRect.width + 'px');
      stage.style.setProperty('--hero-hotspots-map-height', mapRect.height + 'px');
      stage.setAttribute('data-hero-hotspots-map-ready', 'true');
      return true;
    }

    function measureFromObservedBoxes() {
      if (!observedFrameBox || !observedStageBox) return false;
      var frameRect = {
        left: (observedStageBox.width - observedFrameBox.width) / 2,
        top: (observedStageBox.height - observedFrameBox.height) / 2,
        width: observedFrameBox.width,
        height: observedFrameBox.height
      };
      var stageRect = {
        left: 0,
        top: 0,
        width: observedStageBox.width,
        height: observedStageBox.height
      };
      return updateMap(frameRect, stageRect);
    }

    function measureFallback() {
      if (!frame || !stage || !image) return false;
      return updateMap(frame.getBoundingClientRect(), stage.getBoundingClientRect());
    }

    function scheduleMeasure() {
      if (updateFrame) window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(function () {
        updateFrame = null;
        if (!measureFromObservedBoxes() && !resizeObserver) {
          measureFallback();
        }
      });
    }

    cleanupCallbacks.push(function () {
      if (updateFrame) {
        window.cancelAnimationFrame(updateFrame);
        updateFrame = null;
      }
      if (stage) stage.removeAttribute('data-hero-hotspots-map-ready');
    });

    if (image) {
      addListener(image, 'load', scheduleMeasure, controller, cleanupCallbacks);
    }

    if (window.ResizeObserver && frame && stage) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var box = getObservedBox(entry);
          if (entry.target === frame) {
            observedFrameBox = box;
          } else if (entry.target === stage) {
            observedStageBox = box;
          }
        });
        scheduleMeasure();
      });
      resizeObserver.observe(frame);
      resizeObserver.observe(stage);
      cleanupCallbacks.push(function () {
        resizeObserver.disconnect();
        resizeObserver = null;
        observedFrameBox = null;
        observedStageBox = null;
      });
    } else {
      addListener(window, 'resize', scheduleMeasure, controller, cleanupCallbacks);
      addListener(window, 'orientationchange', scheduleMeasure, controller, cleanupCallbacks);
    }

    return scheduleMeasure;
  }

  function addListener(target, eventName, handler, controller, cleanupCallbacks) {
    if (controller) {
      target.addEventListener(eventName, handler, { signal: controller.signal });
      return;
    }
    target.addEventListener(eventName, handler);
    if (cleanupCallbacks) {
      cleanupCallbacks.push(function () {
        target.removeEventListener(eventName, handler);
      });
    }
  }

  function destroyScope(scope) {
    (scope || document).querySelectorAll('[data-hero-product-hotspots]').forEach(function (root) {
      if (root.heroProductHotspotsAbort) {
        root.heroProductHotspotsAbort.abort();
      }
      if (root.heroProductHotspotsCleanups) {
        root.heroProductHotspotsCleanups.forEach(function (cleanup) {
          cleanup();
        });
      }
      setStickyOverlapSuspended(root, false);
      delete root.heroProductHotspotsAbort;
      delete root.heroProductHotspotsCleanups;
      delete root.heroProductHotspotsSetActive;
      delete root.dataset.heroHotspotsBound;
    });
  }

  function bindDesignModeDrag(root) {
    var area = root.querySelector('.hero-product-hotspots__pins') || root.querySelector('[data-hero-hotspots-area]') || root;

    root.querySelectorAll('[data-hero-hotspot-pin]').forEach(function (pin) {
      pin.addEventListener('pointerdown', function (event) {
        if (event.button !== 0) return;
        var rect = area.getBoundingClientRect();
        var moved = false;
        var lastX = null;
        var lastY = null;

        function setFromPointer(pointerEvent) {
          var x = ((pointerEvent.clientX - rect.left) / rect.width) * 100;
          var y = ((pointerEvent.clientY - rect.top) / rect.height) * 100;
          x = Math.max(0, Math.min(100, Math.round(x)));
          y = Math.max(0, Math.min(100, Math.round(y)));
          lastX = x;
          lastY = y;
          pin.style.setProperty('--x', x + '%');
          pin.style.setProperty('--y', y + '%');
          pin.style.setProperty('--mx', x + '%');
          pin.style.setProperty('--my', y + '%');
          var coords = pin.querySelector('[data-hero-hotspot-coords]');
          if (coords) coords.textContent = 'Preview X ' + x + ' / Y ' + y;
        }

        function onMove(moveEvent) {
          moved = true;
          pin.classList.add('is-dragging');
          setFromPointer(moveEvent);
        }

        function onUp() {
          pin.classList.remove('is-dragging');
          window.removeEventListener('pointermove', onMove);
          window.removeEventListener('pointerup', onUp);
          if (moved) {
            var text = 'Desktop X position: ' + lastX + ', Desktop Y position: ' + lastY + ', Mobile X position: ' + lastX + ', Mobile Y position: ' + lastY;
            var coords = pin.querySelector('[data-hero-hotspot-coords]');
            var note = root.querySelector('[data-hero-hotspot-note]');
            if (coords) coords.textContent = 'Copy to settings: X ' + lastX + ' / Y ' + lastY;
            if (note) {
              note.classList.add('is-active');
              note.textContent = 'Use these values in the selected hotspot block before saving: X ' + lastX + ', Y ' + lastY + '.';
            }
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(text).catch(function () {});
            }
            pin.dataset.dragged = 'true';
            window.setTimeout(function () {
              delete pin.dataset.dragged;
            }, 0);
          }
        }

        if (pin.setPointerCapture) pin.setPointerCapture(event.pointerId);
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp, { once: true });
      });

      pin.addEventListener('click', function (event) {
        if (pin.dataset.dragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    });
  }

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-hero-product-hotspots]').forEach(initHeroProductHotspots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScope(document);
    });
  } else {
    initScope(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyScope(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var hotspot = event.target && event.target.closest ? event.target.closest('[data-hero-hotspot]') : null;
    if (!hotspot) return;
    var root = hotspot.closest('[data-hero-product-hotspots]');
    if (!root) return;
    initHeroProductHotspots(root);
    if (typeof root.heroProductHotspotsSetActive === 'function') {
      root.heroProductHotspotsSetActive(hotspot.dataset.heroHotspotId);
    }
  });
})();
